import { Fetch } from 'lib';

type RequestResponses = {};

type RequestParameters = {
  id: string;
};

const deleteSpecialOffer = async (params: RequestParameters) =>
  await Fetch<RequestResponses, RequestParameters>({
    url: 'adminSpecialOffer/deleteSpecialOffer',
    method: 'DELETE',
    params,
  });

export { deleteSpecialOffer };
